export function useButtonDisabled(hasPrivileges: boolean, disabled?: boolean): boolean {
    if (!hasPrivileges) return true;
    return disabled ?? false;
}
